import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`

  #web-inlet {
    * {
      box-sizing: border-box;
      font-family: "Inter", sans-serif;
    }

    textarea[disabled], button[disabled], input[disabled] {
      cursor: not-allowed !important;
    }
  }

`

export default GlobalStyle
